export const USER_TYPES = {
  PROFESSIONAL_SERVICES: 'professional-services',
  ACADEMIC: 'academic',
  STUDENT: 'student',
} as const;

export const CONTRACT_TYPES = {
  PROFESSIONAL_SERVICES: 'professional-services',
  ACADEMIC: 'academic',
  NOT_TEACHING_AND_RESEARCH: 'not teaching and/or research',
} as const;

export const DEFAULT_PARAMS = {
  USER_TYPE: USER_TYPES.PROFESSIONAL_SERVICES,
  DEPARTMENT: '',
  ROLE_DEPARTMENT_ID: '',
  CONTRACT_TYPE: CONTRACT_TYPES.NOT_TEACHING_AND_RESEARCH,
} as const;
